export const DEFAULT_POST_AUTH_REDIRECT = "/dashboard";

function isSafeInternalPath(path: string): boolean {
  if (!path || !path.startsWith("/")) return false;
  if (path.startsWith("//")) return false;
  if (path.includes("\\")) return false;
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(path)) return false;
  return true;
}

export function sanitizeRedirectPath(redirect: string | null | undefined): string | null {
  if (!redirect) return null;

  const candidate = String(redirect).trim();
  if (!candidate) return null;
  if (!isSafeInternalPath(candidate)) return null;

  return candidate;
}

export function getSafeRedirectOrDefault(
  redirect: string | null | undefined,
  fallback: string = DEFAULT_POST_AUTH_REDIRECT
): string {
  return sanitizeRedirectPath(redirect) || fallback;
}

export function buildRedirectAwarePath(basePath: string, redirectTarget: string): string {
  const params = new URLSearchParams();
  params.set("redirect", redirectTarget);
  return `${basePath}?${params.toString()}`;
}
